import { render, staticRenderFns } from "./Planes.vue?vue&type=template&id=daef0b00&"
import script from "./Planes.vue?vue&type=script&lang=js&"
export * from "./Planes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports